import { Controller } from "@hotwired/stimulus"
import {
  Chart,
  LineController, LineElement, PointElement,
  BarController, BarElement,
  LinearScale, CategoryScale, Filler, Tooltip,
} from "chart.js"

Chart.register(
  LineController, LineElement, PointElement,
  BarController, BarElement,
  LinearScale, CategoryScale, Filler, Tooltip,
)

// data-controller="chart"
// data-chart-type-value="area|bar"
// data-chart-variant-value="full|sparkline"  (default: "full")
// data-chart-labels-value='["Jan","Feb",...]'
// data-chart-datasets-value='[{"label":"...","data":[...]}]'
export default class extends Controller {
  static values = {
    type: String,
    variant: { type: String, default: "full" },
    labels: Array,
    datasets: Array,
  }

  connect() {
    const type = this.typeValue === "bar" ? "bar" : "line"
    const sparkline = this.variantValue === "sparkline"

    const rootStyles = getComputedStyle(document.documentElement)
    const elStyles = getComputedStyle(this.element)
    const pick = (name, fallback) =>
      (elStyles.getPropertyValue(name).trim() || rootStyles.getPropertyValue(name).trim() || fallback)
    const primary = pick("--chart-color", pick("--rian-primary", "#6344F5"))
    const primarySoft = pick("--chart-fill", pick("--rian-primary-soft", "rgba(99, 68, 245, 0.15)"))
    const inkSubtle = rootStyles.getPropertyValue("--ink-3").trim() || "#94A3B8"
    const lineColor = rootStyles.getPropertyValue("--line").trim() || "#F1F5F9"

    const datasets = this.datasetsValue.map((ds) => {
      const fill = ds.fillColor || primarySoft
      const stroke = ds.color || primary
      if (type === "line") {
        return {
          ...ds,
          borderColor: stroke,
          backgroundColor: fill,
          fill: true,
          tension: 0.4,
          pointRadius: sparkline ? 0 : 0,
          pointHoverRadius: sparkline ? 0 : 4,
          borderWidth: sparkline ? 1.5 : 2,
        }
      }
      return {
        ...ds,
        backgroundColor: stroke,
        borderRadius: sparkline ? 1 : 4,
        borderWidth: 0,
      }
    })

    const fullScales = {
      x: {
        grid: { display: false },
        ticks: { font: { family: "Plus Jakarta Sans", size: 11 }, color: inkSubtle },
      },
      y: {
        grid: { color: lineColor },
        ticks: { font: { family: "Plus Jakarta Sans", size: 11 }, color: inkSubtle },
        border: { display: false },
        beginAtZero: true,
      },
    }

    const sparklineScales = {
      x: { display: false },
      y: { display: false, beginAtZero: true },
    }

    this.chart = new Chart(this.element, {
      type,
      data: { labels: this.labelsValue, datasets },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        animation: sparkline ? false : undefined,
        layout: sparkline ? { padding: 0 } : undefined,
        plugins: {
          legend: { display: false },
          tooltip: sparkline
            ? { enabled: false }
            : { mode: "index", intersect: false },
        },
        scales: sparkline ? sparklineScales : fullScales,
        elements: sparkline ? { point: { radius: 0 } } : undefined,
      },
    })
  }

  disconnect() {
    this.chart?.destroy()
  }
}
